export default function () {
	const self = {};

	const _private = {
		handleCartUpdate: function (e, response) {
			if (response.status !== 'ok') {
				return;
			}

			const data = response.data || {};
			const count = data.count || 0;
			const sum = data.total || 0;

			self.changeCount(count);
			self.changeSum(sum);
		},

		initEventListeners: function () {
			$(document).on('shop_cart_add', this.handleCartUpdate);
			$(document).on('shop_cart_update', this.handleCartUpdate);
			$(document).on('shop_cart_delete', this.handleCartUpdate);
			$(document).on('shop_cart_clear', this.handleCartUpdate);
		}
	};

	$.extend(self, {
		changeCount: function (count) {
			count = +count;
			const $mobileCart = $('.e-header__cart-quantity');
			$('.basket-info__quantity').html(count);
			$mobileCart.html(count);
			if (count === 0) {
				$('.basket-info').addClass('basket-info_empty');
				$('.basket-info__text_common').addClass('js-hidden');
				$('.basket-info__text_empty').removeClass('js-hidden');
			} else {
				$('.basket-info').removeClass('basket-info_empty');
				$('.basket-info__text_empty').addClass('js-hidden');
				$('.basket-info__text_common').removeClass('js-hidden');
			}
		},

		changeSum: function (sum) {
			$('.basket-info__summ').html(sum);
		}
	});

	_private.initEventListeners();

	return self;
}
